import React, { useState } from 'react';
import { Calendar, Dumbbell, CheckCircle, Archive, Trash2 } from 'lucide-react';
import ExpandableText from '../ui/ExpandableText';

const StudentDetailTasksTab = ({
  activeTasks,
  studentId,
  setActiveModal,
  handleDeleteProgram,
  handleDeleteProgramPermanent,
}) => {
  const [pendingArchiveId, setPendingArchiveId] = useState(null);
  const [pendingDeleteProgId, setPendingDeleteProgId] = useState(null);

  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-6 border-b border-slate-100 dark:border-slate-700 pb-4">
        <h3 className="font-bold text-lg text-slate-800 dark:text-white flex items-center gap-2">
          <Dumbbell className="text-blue-500 dark:text-blue-400" /> Bireysel Antrenman Görevleri
        </h3>
        <button
          onClick={() => setActiveModal('newProgram')}
          className="text-blue-600 dark:text-blue-400 text-sm font-bold bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-100 dark:hover:bg-blue-900/50 px-4 py-2 rounded-lg transition-colors text-center"
        >
          Görev Ekle
        </button>
      </div>
      {activeTasks.length > 0 ? (
        <div className="space-y-4">
          {activeTasks.map((prog) => (
            <div
              key={prog.id}
              className={`border rounded-2xl p-4 sm:p-5 transition-colors ${
                prog.completed
                  ? 'bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 opacity-80'
                  : 'border-slate-100 dark:border-slate-700 hover:border-blue-200 dark:hover:border-blue-800'
              }`}
            >
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
                <div className="flex items-center gap-3">
                  <span className="bg-slate-900 dark:bg-slate-700 text-white text-xs font-bold px-3 py-1 rounded-lg">
                    {prog.day}
                  </span>
                </div>
                <div className="flex items-center justify-between sm:justify-end gap-2 w-full sm:w-auto">
                  <span className="text-[10px] font-bold text-slate-400 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 px-2 py-1 rounded flex items-center gap-1">
                    <Calendar size={12} /> {prog.date || 'Tarih Yok'}
                  </span>
                  {prog.completed && (
                    <span className="flex items-center gap-1 text-emerald-600 dark:text-emerald-400 text-xs font-bold bg-emerald-100 dark:bg-emerald-900/30 px-3 py-1.5 rounded-md">
                      <CheckCircle size={16} /> Tamamlandı
                    </span>
                  )}
                  {pendingArchiveId === prog.id ? (
                    <div className="flex items-center gap-1.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 px-3 py-1.5 rounded-xl">
                      <span className="text-xs font-bold text-amber-700 dark:text-amber-400">Arşivlensin mi?</span>
                      <button
                        onClick={() => { handleDeleteProgram(studentId, prog.id); setPendingArchiveId(null); }}
                        className="text-xs font-black text-white bg-amber-500 hover:bg-amber-600 px-2.5 py-1 rounded-lg transition-colors"
                      >
                        Evet
                      </button>
                      <button
                        onClick={() => setPendingArchiveId(null)}
                        className="text-xs font-black text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 px-2.5 py-1 rounded-lg transition-colors"
                      >
                        Hayır
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => setPendingArchiveId(prog.id)}
                      className="flex items-center gap-1 text-amber-500 hover:text-amber-700 bg-amber-50 dark:bg-amber-900/20 hover:bg-amber-100 dark:hover:bg-amber-900/40 px-2.5 py-2 rounded-lg transition-colors text-xs font-bold"
                      title="Geçmişe Taşı"
                    >
                      <Archive size={14} /> Arşivle
                    </button>
                  )}
                  {pendingDeleteProgId === prog.id ? (
                    <div className="flex items-center gap-1.5 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 px-3 py-1.5 rounded-xl">
                      <span className="text-xs font-bold text-red-700 dark:text-red-400">Silinsin mi?</span>
                      <button
                        onClick={() => { handleDeleteProgramPermanent(studentId, prog.id); setPendingDeleteProgId(null); }}
                        className="text-xs font-black text-white bg-red-500 hover:bg-red-600 px-2.5 py-1 rounded-lg transition-colors"
                      >
                        Evet
                      </button>
                      <button
                        onClick={() => setPendingDeleteProgId(null)}
                        className="text-xs font-black text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 px-2.5 py-1 rounded-lg transition-colors"
                      >
                        Hayır
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => setPendingDeleteProgId(prog.id)}
                      className="flex items-center gap-1 text-red-500 hover:text-red-700 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/40 px-2.5 py-2 rounded-lg transition-colors text-xs font-bold"
                      title="Görevi Sil"
                    >
                      <Trash2 size={14} /> Sil
                    </button>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4">
                {[
                  { label: 'Isınma', color: 'text-orange-500', value: prog.warmup },
                  { label: 'Ana Set', color: 'text-blue-500', value: prog.main },
                  { label: 'Soğuma', color: 'text-emerald-500', value: prog.cooldown },
                ].map((s) => (
                  <div
                    key={s.label}
                    className="bg-white dark:bg-slate-800 p-3 rounded-xl border border-slate-100 dark:border-slate-700 shadow-sm"
                  >
                    <p className={`text-[10px] font-bold ${s.color} uppercase mb-1`}>
                      {s.label}
                    </p>
                    <p
                      className={`text-sm font-bold text-slate-700 dark:text-slate-300 ${
                        prog.completed ? 'line-through opacity-70' : ''
                      }`}
                    >
                      <ExpandableText text={s.value} maxLength={40} />
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700">
          <Calendar size={40} className="mx-auto text-slate-300 dark:text-slate-600 mb-4" />
          <p className="font-bold text-slate-500 dark:text-slate-400 mb-2">Henüz Görev Yok</p>
          <p className="text-sm text-slate-400 dark:text-slate-500">
            Bu öğrenci için bu hafta görev planlanmamış.
          </p>
        </div>
      )}
    </>
  );
};

export default StudentDetailTasksTab;
